import { PaginatorDesignTokens } from '@primeuix/themes/types/paginator';
import { colors } from '../colors';

export const paginator: PaginatorDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: 'none',
      },
      navButton: {
        color: colors.textWeak,
        hoverColor: '{text-color}',
        hoverBackground: colors.blue500,
        selectedColor: '{text-color}',
        selectedBackground: colors.blue400,
      },
    },
  },
};
